export enum PillButtonSize {
  MEDIUM,
  SMALL,
}

export interface PillButtonDropdownItems {
  id: string;
  text: string;
  icon?: string;
}

export interface PillButtonImageProps {
  src: string;
  alt?: string;
  size?: number;
}
